import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function BrandDeal() {
  return (
    <ToolShell
      testid="tool-brand-deal-page"
      eyebrow="Pro Tool" toolKey="brand_deal"
      title="Brand Deal Pitch Generator"
      subtitle="Cold outreach + follow-up + pitch angles for a specific brand. Confident, specific, never hypey."
      endpoint="/tools/brand-deal"
      tier="pro"
      transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "brand_name", label: "Target brand", type: "text", required: true, placeholder: "e.g. Cressi" },
        { key: "brand_context", label: "What you know about them", type: "textarea", rows: 3, placeholder: "e.g. Just launched a new freediving fin range. Distributing in EU." },
        { key: "your_angle", label: "Why this is a fit", type: "textarea", rows: 3, placeholder: "e.g. My audience is exactly their target. I have testing experience with their existing line." },
        { key: "deliverable_pref", label: "Preferred deliverables (optional)", type: "text", placeholder: "e.g. 1 reel + 1 carousel + 3 stories" },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock testid="output-fit" label="Fit Summary">{o.fit_summary}</OutputBlock>
          {o.cold_email && (
            <div className="dms-card p-6 space-y-3" data-testid="output-cold-email">
              <div className="dms-label">Cold Email</div>
              <div><span className="dms-label">Subject</span><div className="mt-1 font-semibold">{o.cold_email.subject}</div></div>
              <div><span className="dms-label">Body</span><div className="mt-1 whitespace-pre-wrap leading-relaxed">{o.cold_email.body}</div></div>
            </div>
          )}
          {o.follow_up_email && (
            <div className="dms-card p-6 space-y-3" data-testid="output-follow-up">
              <div className="dms-label">Follow-up Email</div>
              <div><span className="dms-label">Subject</span><div className="mt-1 font-semibold">{o.follow_up_email.subject}</div></div>
              <div><span className="dms-label">Body</span><div className="mt-1 whitespace-pre-wrap leading-relaxed">{o.follow_up_email.body}</div></div>
            </div>
          )}
          {o.pitch_angles && (
            <OutputBlock testid="output-pitch-angles" label="Pitch Angles">
              <div className="space-y-3">
                {o.pitch_angles.map((a, i) => (
                  <div key={i} className="dms-card p-4">
                    <div className="font-semibold text-[#0A2342]">{a.angle}</div>
                    <div className="text-sm text-[#475569] mt-1">Deliverable: {a.deliverable}</div>
                    <div className="text-xs text-[#64748B] mt-1">KPIs: {a.kpis}</div>
                  </div>
                ))}
              </div>
            </OutputBlock>
          )}
          {o.media_kit_blurb && <OutputBlock testid="output-media-kit" label="Media Kit Blurb" copyValue={o.media_kit_blurb}><div className="whitespace-pre-wrap leading-relaxed">{o.media_kit_blurb}</div></OutputBlock>}
          {o.rate_anchor && <OutputBlock testid="output-rate" label="Rate Anchor">{o.rate_anchor}</OutputBlock>}
        </>
      )}
    />
  );
}
